import LeavePromptModal from './LeavePromptModal';

export default LeavePromptModal;
